<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}">
        <v-form @submit.prevent="add_comment(comment)">
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('add_comment_modal')">{{$t("закрыть")}}</v-icon>
            <v-card-title class="display-1 mb-4">{{$t("Оставить комментарий")}}</v-card-title>
            <v-layout mb-4>
                <v-flex xs12>
                    <div class="grey-text mb-2">{{$t("Введите текст")}}</div>
                    <textareaBase :placeholder="$t('Введите текст')" rows="4" @change="comment_text($event.target.value)" />
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-layout align-center wrap>
                    <buttonRed :class="{'flex xs12 mr-0 mb-2': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}">{{$t("Отправить")}}</buttonRed>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import textareaBase from '@/components/ui/inputs/base/textarea';
import inputBase from '@/components/ui/inputs/base/input';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    textareaBase,
    inputBase,
  },
  data() {
    return {
      comment: {
        text: '',
      },
    };
  },
  computed: {
    ...mapGetters('ideas_bank', [
      'themes',
      'ideas_bank_modal',
      'add_comment_modal',
    ]),
  },
  methods: {
    ...mapMutations('ideas_bank', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapActions('ideas_bank/comments', [
      'add_comment',
    ]),
    comment_text(ev) {
      this.comment.text = ev;
    },
  },


};
</script>
